module.exports = __webpack_public_path__ + "img/logo.a29aa870.png";